<template>
  <Loading variant="page" />
</template>

<script>
import Loading from '@/components/Loading';
import utils from '@/utils';
import { bootstrapProxyReadonly } from '@/api/chatProxyReadonly';

export default {
  components: { Loading },
  async mounted() {
    try {
      const data = await bootstrapProxyReadonly({
        role: this.$store.state.role.query,
        idToken: this.$store.state.user.idToken,
        authId: this.$store.state.user.sub.replace(/^auth0\|/, ''),
        proxyUserId: this.$route.query.proxyUserId
      });

      // Order matters: set effectiveSub before building rooms, build rooms before navigating
      this.$store.dispatch('setUser', { effectiveSub: data.effectiveSub });
      // App.vue listens for this to build rooms + Firestore listeners, same as getProjects()
      this.$root.$emit('proxy-projects-loaded', data.projects, data.userId);

      // Keep the full query — dropping proxyUserId breaks F5 and deep links
      this.$router.replace({ name: 'room', query: { ...this.$route.query } });
    } catch (e) {
      console.error(e);
      // Treat 403/404 like any other error: go back, no dedicated error screen
      location.href = utils.getBackUrl(this.$store.state.role.name);
    }
  }
};
</script>
